import { SvgIcon, SvgIconProps } from "@mui/material";

export function RoomIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M3,21 L3,19 L5,19 L5,3 L15,3 L15,4 L19,4 L19,19 L21,19 L21,21 L17,21 L17,6 L15,6 L15,21 L3,21 Z M7.0375,5 L7.0375,19 L7.0375,5 Z M11,13 C11.2833333,13 11.5208333,12.9041667 11.7125,12.7125 C11.9041667,12.5208333 12,12.2833333 12,12 C12,11.7166667 11.9041667,11.4791667 11.7125,11.2875 C11.5208333,11.0958333 11.2833333,11 11,11 C10.7166667,11 10.4791667,11.0958333 10.2875,11.2875 C10.0958333,11.4791667 10,11.7166667 10,12 C10,12.2833333 10.0958333,12.5208333 10.2875,12.7125 C10.4791667,12.9041667 10.7166667,13 11,13 Z M7,19 L13,19 L13,5 L7,5 L7,19 Z" />
    </SvgIcon>
  );
}
